import { bool, exact, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const matchType = exact({
  isExact: bool,
  /**
   * This currently can't be more specific due to the dynamic nature of params
   */
  params: shape({
    company: string,
  }),
  path: string,
  url: string,
});
